import { useAuth } from 'context/AuthProvider';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody,  CardFooter, CardHeader,  Col, Form, FormGroup, Input, Label } from 'reactstrap'
import { apiDepartamentosService } from 'services/apiDepartamentosService';
import { apiexportacionService } from 'services/apiExportacionService';

const ExportadorFichajesDetallados = () => {
    const {empresa} = useAuth();
    const [departamentos, setDepartamentos] = useState([]);
    

    const [desde, setDesde] = useState( new Date().toISOString().split("T")[0]);
    const [hasta, setHasta] = useState( new Date().toISOString().split("T")[0]);
    const [departamentoId, setDepartamentoId] = useState("Todos");

    const handleSubmit = async (e) =>{
        e.preventDefault();
        await apiexportacionService.getInformeFichajesCompleto(empresa.id, desde, hasta, departamentoId)
        console.log({desde, hasta, departamentoId})
    }

    useEffect(() => {
      const fetchData = async () =>{
        const response = await apiDepartamentosService.getAll(empresa.id,0,1000);
        setDepartamentos(response.content)
      }
      fetchData();
    }, [empresa.id])
    

    return (
        <>
            <Card className='shadow'>
                <Form onSubmit={handleSubmit}>
                    <CardHeader>
                        Informe de fichajes detallado
                    </CardHeader>

                    <CardBody>
                        <FormGroup row>


                            <Col >
                                <Label for="desde" >Fecha desde:</Label>
                                <Input type="date" id='desde' value={desde} onChange={(e) => setDesde(e.target.value)}> </Input>
                            </Col>


                            <Col >
                                <Label for='hasta'>Fecha hasta:</Label>
                                <Input type="date" id="hasta" value={hasta} onChange={(e) => setHasta(e.target.value)}>  </Input>
                            </Col>


                        </FormGroup>
                        <FormGroup row>
                            <Col>
                            <Label  for='departameto'>departameto:</Label>
                        
                                <Input type="select" name="select" id="departameto" value={departamentoId} onChange={(e) => setDepartamentoId(e.target.value)}>
                                    <option value={"Todos"}>Todos los departamentos</option>
                                    {departamentos.map((departamento, index)=> (
                                        <option key={index} value={departamento.id}>{departamento.nombre}</option>
                                    ))}
                                </Input>
                                </Col>
                        </FormGroup>
                        
                    </CardBody>

                    <CardFooter className='text-center'>
                        <Button color="success" type='submit'>Descargar</Button>
                    </CardFooter>
                </Form>
            </Card>
        </>

    )
}

export default ExportadorFichajesDetallados
